import UserService from 'Services/user';

export default {
	name: 'RegistrationModal',
	created() {
		this.credential.email = this.$route.query.email || '';
		this.credential.plan = this.$route.query.plan || '';

		this.isFreeReg = this.credential.plan === '' || this.credential.plan === 'free';
	},
	mounted() {
		document.documentElement.style.overflow = 'hidden';
		document.body.scroll = 'no';
	},
	data() {
		return {
			isMerchantEnabled: process.env.FEATURE_MERCHANT === 'true',
			isLoading: false,
			showPassword: false,
			passwordUnused: '',
			credential: {
				email: '',
				password: '',
				firstname: '',
				lastname: '',
				plan: ''
			},
			isFreeReg: false,
			accepted: false,
			isLoginModalVisible: false
		};
	},
	computed: {
		touched() {
			if (this.fields.repassword) {
				return this.fields.repassword.touched;
			}
			return false;
		}
	},
	methods: {
		registration() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.isLoading = true;
					UserService.registration(this.credential)
						.then(response => {
							this.$store.commit('LOGIN_USER', { email: this.credential.email });
							if (this.isMerchantEnabled) {
								this.$store.commit('UPDATE_SUB_INFO', {
									status: 'active',
									plan: { name: 'free', trialDays: 0 }
								});
								this.$store.commit('UPDATE_MAX_DEVICES', 1);
							}
							this.$router.push(this.$route.query.redirect || '/');
							this.isLoading = false;
						})
						.catch(error => {
							this.isLoading = false;
							this.errors.add({
								field: 'apierror',
								msg: error.response.data.Message
							});
						});
				}
			});
		}
	},
	destroyed() {
		document.documentElement.style.overflow = 'auto';
		document.body.scroll = 'yes';
	}
};



// WEBPACK FOOTER //
// ./app/components/registration-modal/script.js